module.exports = __webpack_public_path__ + "img/lincplus_02.39376dbb.png";